exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bookCover{display:inline-block;position:relative}.bookCover .emptyCoverTitle{width:85px;position:absolute;left:14px;color:#fff;top:20px;font-size:.8em;overflow:hidden;max-height:78%}.bookCover .bookDetails{vertical-align:middle;padding-left:10px;display:inline-block;text-align:left;width:220px}.bookCover .title{font-style:italic;display:block;word-break:break-word}.bookCover .author{display:inline-block;word-break:break-word}.bookCover .quizTakenIcon{box-shadow:0 2px 3px rgba(0,0,0,.55);border-radius:16px}.bookCover .quizTakenIcon,.bookCover .quizTakenIconSquare{float:right;width:32px;height:auto;position:absolute;right:-16px;top:-16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/books/book_cover.scss
// module id = 1382
// module chunks = 0